import Image from "next/image";
import { Heading } from "../design-system/atoms/Heading";
import FeatureItem from "../design-system/molecules/FeatureItem";
import type { BlockProps } from "./blocks/registry";
import { Paragraph } from "../design-system/atoms/Paragraph";

type StrapiMedia = {
  url?: string;
  alternativeText?: string;
};

type FaciliteItem = {
  id?: number | string;
  titre?: string;
  descr?: string;
  icon?: StrapiMedia;
};

type FaciliteMetierData = {
  id?: number | string;
  documentId?: string;
  __component?: string;
  titre?: string;
  description?: string;
  image?: StrapiMedia;
  items?: FaciliteItem[];
  [key: string]: unknown;
};

export default function FaciliteMetier({
  data,
}: BlockProps<FaciliteMetierData>) {
  if (!data) return null;

  const titre = data.titre || "";
  const keyword = "Les Menus Services";
  const items = Array.isArray(data.items) ? data.items : [];

  const titleContent = titre.includes(keyword) ? (
    <>
      {titre.split(keyword)[0]}
      <span className="text-secondary font-semibold">{keyword}</span>
      {titre.split(keyword)[1]}
    </>
  ) : (
    titre
  );

  return (
    <section className="bg-muted py-6 lg:py-8 2xl:py-10">
      <div className="lms-container">

        <div className="mb-5 text-center">
          <Heading
            as="h2"
            className="mb-5 text-4xl font-bold text-center text-text lg:text-[44px] 2xl:mb-10 2xl:text-5xl"
          >
            {titleContent}
          </Heading>

          <Paragraph className="text-center">
            {data.description || ""}
          </Paragraph>
        </div>

        <div className="container mx-auto grid items-center gap-6 lg:grid-cols-2 2xl:gap-10">

          {/* IMAGE */}

          <div className="hidden justify-center lg:flex">
            <Image
              src={data.image?.url || "/fallback-image.jpg"}
              alt={data.image?.alternativeText || ""}
              width={805}
              height={800}
              className="h-[380px] w-full max-w-[500px] rounded-2xl object-cover xl:h-[420px] 2xl:h-[450px]"
            />
          </div>

          {/* ITEMS */}
          <div className="grid grid-cols-2 gap-4 2xl:gap-6">
            {items.map((item, index) => (
              <FeatureItem
                key={item.id ?? index}
                iconSrc={item.icon?.url || "/fallback-icon.svg"}
                title={item.titre || ""}
                text={item.descr || ""}
                className="rounded-2xl bg-white p-2 shadow-[0_6px_20px_rgba(0,0,0,0.06)] transition hover:shadow-[0_8px_24px_rgba(0,0,0,0.1)] 2xl:p-6"
                titleClassName="text-primaryGreen font-bold text-[16px] 2xl:text-lg"
                style={{ border: "none" }}
              />
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}